<template>
<div id="app">
  <router-view/>
</div>
</template>

<script>
import icon from '@/assets/img/icon.png';
import {
  mapMutations
} from 'vuex';
export default {
  name: 'App',
  methods: {
    ...mapMutations(['setLang'])
  },
  mounted() {
    this.setLang(localStorage.getItem('local'))
    const link = document.createElement("link"),
      dom = document.querySelector('head');
    link.rel = "shortcut icon";
    link.href = icon;
    link.type = "image/png";
    dom.insertBefore(link, dom.firstChild);
  }
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue